import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'conditions',
    label: 'Conditions',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'conditionSets',
    label: 'Conditions Sets',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'priorToType',
    label: 'Prior to',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'message',
    label: 'Condition',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'borrowerMessage',
    label: 'Borrower Facing Condition',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'assignee',
    label: 'Assignee',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'subCompanyMessage',
    label: 'Sub Company Facing Condition',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'formVariant',
    label: 'Form Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'state',
    label: 'State',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'formId',
    label: 'Form',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'description',
    label: 'Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const addConditionsAndConditionsSetsForm = {
  name: FormNames.ADD_CONDITIONS_AND_CONDITIONS_SETS,
  label: 'Add Conditions and Conditions Sets',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
